export const MAX_FILE_SIZE = 25 * 1024 * 1024; // 25 MB
export const MAX_FILE_SIZE_MB = 25;
